import { getColorScheme } from '../../colors';
import getBorderFocusStyles from '../../getBorderFocusStyles';
var toolbarCustomItemStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    var colors = getColorScheme(v.colorScheme);
    var borderWidth = siteVariables.borderWidth;
    var borderFocusStyles = getBorderFocusStyles({
      variables: siteVariables
    });
    return Object.assign({
      position: 'relative',
      backgroundColor: v.background,
      borderColor: 'transparent',
      borderWidth: borderWidth,
      borderStyle: 'solid',
      height: v.itemHeight,
      color: v.foreground || colors.foreground1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }, p.fitted !== true && p.fitted !== 'horizontally' && {
      paddingLeft: v.customItemHorizontalPadding,
      paddingRight: v.customItemHorizontalPadding
    }, {}, p.fitted !== true && p.fitted !== 'vertically' && {
      paddingTop: v.customItemVerticalPadding,
      paddingBottom: v.customItemVerticalPadding
    }, {
      ':focus': borderFocusStyles[':focus'],
      ':focus-visible': borderFocusStyles[':focus-visible']
    });
  }
};
export default toolbarCustomItemStyles;
//# sourceMappingURL=toolbarCustomItemStyles.js.map
